import { Alert, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import useClientContext from "../../../context/useClientContext";
import type { StartResyncResult } from "./StartResyncDialog";
import StartResyncDialog from "./StartResyncDialog";

interface Props {
  lastSyncTime: string | undefined;
}

const ResyncSection = ({ lastSyncTime }: Props) => {
  const { hasPermissions } = useClientContext();

  const [startResyncInfo, setStartResyncInfo] = useState<StartResyncResult>();
  const [showResyncDialog, setShowResyncDialog] = useState(false);

  const hasAccessToManage = hasPermissions(["ManageClientIntegrations"]);

  const handleResyncClick = () => {
    if (hasAccessToManage) {
      setShowResyncDialog(true);
    }
  };

  const handleResyncStart = (result: StartResyncResult) => {
    setShowResyncDialog(false);
    setStartResyncInfo(result);
  };

  const formattedLastSyncTime = lastSyncTime ? convertISODateTime(lastSyncTime) : "";

  return (
    <>
      <Stack spacing={3} sx={{ pb: 2 }}>
        <Stack spacing={1}>
          <Typography variant="subtitle2">Setup</Typography>
          {formattedLastSyncTime && (
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <Typography color="textSecondary">Last synchronization:</Typography>
              <Typography>{formattedLastSyncTime}</Typography>
            </Stack>
          )}
        </Stack>
        {hasAccessToManage && (
          <Button variant="outlined" color="secondary" onClick={handleResyncClick} sx={{ width: "9.5rem" }}>
            Re-Synchronization
          </Button>
        )}
        {startResyncInfo && (
          <Alert severity={startResyncInfo.severity} onClose={() => setStartResyncInfo(undefined)}>
            {startResyncInfo.message}
          </Alert>
        )}
      </Stack>
      {showResyncDialog && <StartResyncDialog onClose={() => setShowResyncDialog(false)} onStart={handleResyncStart} />}
    </>
  );
};

export default ResyncSection;
